import {
    BigFarm as BF_CONFIG,
    DEFAULT_CONFIG,
    Empire as EM_CONFIG
} from './game-configs.js'

// the gameId is a string in login events thus the key in mapping is the string
const GAMES_CONFIGS = new Map([
    [`15`, BF_CONFIG],
    [`12`, EM_CONFIG]
])

export const getConfig = (cxf) => {
    const gameConfig = GAMES_CONFIGS.get(cxf.gameId)

    return {
        ...DEFAULT_CONFIG,
        ...gameConfig
    }
}

export {GAMES_CONFIGS}
